module.exports = {
  BaseURL: "https://polar-mesa-07234.herokuapp.com",
};
